export default defineNuxtPlugin({
  name: 'public redirect',
  hooks: {
    'app:created'() {
      const app = useNuxtApp()
      if (app.payload.path?.startsWith('/public/')) {
        // Nuxt will automatically do a redirect to the path contained in the payload.
        app.payload.path = app.payload.path.substring('/public'.length)
      }
    },
  },
})
